import React, { createContext, useContext, useState } from 'react';

const InventoryNavigationContext = createContext();

export const useInventoryNavigation = () => {
  const context = useContext(InventoryNavigationContext);
  if (!context) {
    throw new Error('useInventoryNavigation must be used within an InventoryNavigationProvider');
  }
  return context;
};

export const InventoryNavigationProvider = ({ children }) => {
  const [savedFilters, setSavedFilters] = useState(null);
  const [savedColumns, setSavedColumns] = useState(null);

  const saveFilters = (filters) => {
    setSavedFilters(filters);
  };

  const getSavedFilters = () => {
    return savedFilters;
  };

  const clearSavedFilters = () => {
    setSavedFilters(null);
  };

  const saveColumns = (columns) => {
    setSavedColumns(columns);
  };

  const getSavedColumns = () => {
    return savedColumns;
  };

  const clearSavedColumns = () => {
    setSavedColumns(null);
  };


  const value = {
    saveFilters,
    getSavedFilters,
    clearSavedFilters,
    saveColumns,
    getSavedColumns,
    clearSavedColumns,
  };

  return (
    <InventoryNavigationContext.Provider value={value}>
      {children}
    </InventoryNavigationContext.Provider>
  );
};
